var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { CssContext, defaultCssContextValue } from '.';
import '@citi-icg-172888/icgds/dist/css/icgds.css';
import '@citi-icg-172888/icgds-icons/dist/icgds-icons.css';
const StyleWrapper = (props) => {
    const { Provider } = CssContext;
    const { children } = props, others = __rest(props, ["children"]);
    const contextValue = Object.assign(Object.assign({}, defaultCssContextValue), others);
    if (contextValue.lazyLoad) {
        contextValue.module = true;
    }
    return React.createElement(Provider, { value: contextValue }, children);
};
export default StyleWrapper;
